<template>
  <b-modal
    id="modal_form"
    size="lg"
    ref="modal_form"
    :title="modal_titulo"
    :ok-title="modal_botao"
    close-title="Fechar"
    cancel-title="Cancelar"
    v-model="showModal"
  >
    <template v-if="this.optionSequencia.length > 0">
      <div class="horizontal-scroll">
        <table :class="['vuetable table table-striped tbl-typical']">
          <thead>
            <tr>
              <th style="width: 15%">Cliente</th>
              <th style="width: 15%">Endereço</th>
              <th style="width: 15%">Bairro</th>
              <th style="width: 15%">Municipio</th>
              <th style="width: 10%">Sequência</th>
              <th style="width: 15%">Latitude</th>
              <th style="width: 15%">Longitude</th>
            </tr>
          </thead>
          <tbody v-for="row in this.dados">
            <tr class="bg-gray-light" style="display: table-row">
              <td>
                <span v-if="row.nome !== null">{{ row.nome }}</span>
              </td>
              <td>
                <span v-if="row.endereço !== null">{{ row.endereço }}</span>
              </td>
              <td>
                <span v-if="row.endereço !== null">{{ row.bairro }}</span>
              </td>
              <td>
                <span v-if="row.endereço !== null"
                  >{{ row.municipio }} - {{ row.uf }}</span
                >
              </td>
              <td>
                <multiselect
                  v-model="row.sequencia"
                  :options="optionSequencia"
                  track-by="value"
                  label="label"
                  placeholder="Sequência"
                  tag-placeholder="Selecionar"
                  select-label="Selecionar"
                  :hide-selected="true"
                  selected-label="Selecionado"
                  deselect-label="Remover"
                ></multiselect>
              </td>
              <td>
                <b-form-input
                  type="text"
                  placeholder="Latitude"
                  v-model="latitude"
                  name="latitude"
                >
                </b-form-input>
              </td>
              <td>
                <b-form-input
                  type="text"
                  placeholder="Longitude"
                  v-model="longitude"
                  name="longitude"
                >
                </b-form-input>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>
    <div slot="modal-footer" class="w-100">
      <div class="float-left">
        <spinner v-if="loading" message="Processando..."></spinner>
      </div>
      <div class="float-right">
        <b-btn @click="showModal = false" variant="secondary"> Fechar </b-btn>
        <b-btn @click="onStore()" variant="secondary" :disabled="isDisabled">
          Enviar
        </b-btn>
      </div>
    </div>
  </b-modal>
</template>
<script>
export default {
  props: {
    metodo: { type: Function },
    tabela: "",
    rota: "",
  },
  data() {
    return {
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      showModalGrupo: false,
      isFullscreen: false,
      errors_array: [],
      dados: [],
      optionSequencia: [],
      latitude: "",
      longitude: "",
      helpForm: new Form({
        statusRecord: [],
        params: [],
        carga_id: "",
        docfis_id: "",
      }),
      form: new Form({
        carga_sequencia_entrega: [
          {
            carseqent_id: "",
            sequencia: "",
            docfis_id: "",
            longitude: "",
            latitude: "",
          },
        ],
      }),

      fields: [],
      css: {
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger",
      },
      moreParams: {},
    };
  },
  watch: {
    sequenciaSelected(obj) {
      this.dados.sequencia = obj.value;
    },
  },

  methods: {
    onView() {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Sequência de entregas";
      this.optionSequencia = [];
      this.$refs.modal_form.show();
    },
    getData(id) {
      this.dados = [];
      this.optionSequencia = [];
      this.isDisabled = true;
      this.helpForm.carga_id = id;
      this.helpForm
        .post("/api/expedicao/buscadoc")
        .then((response) => {
          this.i = 1;
          response.carga_sequencia_entrega.forEach((obj) => {
            this.dados.push({
              carseqent_id: obj.carseqent_id,
              nome: obj.carga_doc.doc_carga_doc.doc.doc_cte_partes_env.des_nome,
              endereço:
                obj.carga_doc.doc_carga_doc.doc.doc_cte_partes_env.des_endereco,
              complemento:
                obj.carga_doc.doc_carga_doc.doc.doc_cte_partes_env
                  .des_complemento,
              bairro:
                obj.carga_doc.doc_carga_doc.doc.doc_cte_partes_env.des_bairro,
              municipio:
                obj.carga_doc.doc_carga_doc.doc.doc_cte_partes_env
                  .des_nome_municipio,
              uf: obj.carga_doc.doc_carga_doc.doc.doc_cte_partes_env.des_uf,
              docfis_id: obj.carga_doc.docfis_id,
              sequencia: null,
              latitude: "",
              longitude: "",
            });
            this.optionSequencia.push({
              label: this.i,
              value: this.i,
            });
            this.i = this.i + 1;
          });
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    onStore() {
      this.form.carga_sequencia_entrega = this.dados;
      this.form.carga_sequencia_entrega.forEach((obj, index) => {
        if (obj.sequencia == null) {
          this.form.carga_sequencia_entrega[index].sequencia = null;
        } else {
          this.form.carga_sequencia_entrega[index].sequencia =
            obj.sequencia.value;
        }
        this.form.carga_sequencia_entrega[index].latitude = this.latitude;
        this.form.carga_sequencia_entrega[index].longitude = this.longitude;
      });

      this.loading = true;
      this.isDisabled = true;
      this.form
        .post("/api/expedicao/sequenciar")
        .then((response) => {
          new ReturnApi(response, this);
        })
        .catch((errors) => {
          // this.form.carga_sequencia_entrega.forEach((obj, index)=>{
          //     this.dados[index].sequencia = {label: obj.sequencia.value, value: obj.sequencia.value}
          // })
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    },
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.state.vuetable.filterRow;
      },
    },
    getCurrency: {
      get() {
        return this.$store.getters.currency;
      },
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      },
    },
  },
};
</script>
<style>
.horizontal-scroll {
  overflow-y: auto;
}
</style>